import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, PhoneIcon, HandshakeIcon, DatabaseIcon, UserCheckIcon, EyeIcon, CheckCircleIcon } from 'lucide-react';
const steps = [{
  icon: ClipboardCheckIcon,
  label: 'Pregătire Apel',
  color: 'from-[#357BEB] to-[#2868d8]'
}, {
  icon: PhoneIcon,
  label: 'Apel',
  color: 'from-[#2868d8] to-[#1e5bb8]'
}, {
  icon: HandshakeIcon,
  label: 'Colaborare',
  color: 'from-[#1e5bb8] to-[#132C53]'
}, {
  icon: DatabaseIcon,
  label: 'Indexare Colaborare',
  color: 'from-[#132C53] to-[#0f2340]'
}, {
  icon: UserCheckIcon,
  label: 'Matching Client',
  color: 'from-[#0f2340] to-[#21A366]'
}, {
  icon: EyeIcon,
  label: 'Vizionare',
  color: 'from-[#21A366] to-[#1a8555]'
}, {
  icon: CheckCircleIcon,
  label: 'Tranzacție',
  color: 'from-[#1a8555] to-[#357BEB]'
}];
export function WorkflowSection() {
  return <div className="bg-white rounded-2xl p-8 shadow-md" data-id="element-7092">
      <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0 md:space-x-4" data-id="element-7093">
        {steps.map((step, index) => <Fragment key={step.label} data-id="element-7094">
            <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.15
        }} className="flex flex-col items-center text-center" data-id="element-7095">
              <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center mb-3 shadow-lg`} data-id="element-7096">
                <step.icon className="w-10 h-10 text-white" data-id="element-7097" />
              </div>
              <span className="text-sm font-bold text-[#132C53]" data-id="element-7098">
                {step.label}
              </span>
            </motion.div>
            {index < steps.length - 1 && <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.15 + 0.2
        }} className="hidden md:block w-12 h-1 bg-gradient-to-r from-[#357BEB] to-[#132C53]" data-id="element-7099" />}
          </Fragment>)}
      </div>
    </div>;
}